export default __webpack_public_path__ + "static/media/plshx.12cf5460.gif";